export function toggleScroll(id) {
    const block = document.body;

    id ? block.style.overflow = 'hidden' : block.style.overflow = 'auto';
}
